function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: styles["feed-splash-hero-image"] || "feed-splash-hero-image",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "134",
  height: "114"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a9198431-4ca8-41e3-947c-1cbbc3e855a5",
  "data-name": "New Gradient Swatch 5",
  x1: "-9.96",
  y1: "60.57",
  x2: "109.78",
  y2: "81.12",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".89",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a2a20e68-5b20-4278-8e5b-3d3cb02a1a19",
  x1: "-19.96",
  y1: "60.57",
  x2: "99.78",
  y2: "81.12",
  xlinkHref: "#a9198431-4ca8-41e3-947c-1cbbc3e855a5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "edc4a9b2-14b4-4193-a37d-8fb0916de50b",
  x1: "-57.08",
  y1: "34.67",
  x2: "172.23",
  y2: "74.03",
  xlinkHref: "#a9198431-4ca8-41e3-947c-1cbbc3e855a5"
})), /*#__PURE__*/React.createElement("title", null, "spot_newspaper"), /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "ac2aa931-1993-41de-8f04-f0e2632e64e0",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34 20v82a12 12 0 01-24 0V20z",
  fill: "url(#a9198431-4ca8-41e3-947c-1cbbc3e855a5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34 20v82a12 12 0 01-24 0V20z",
  fill: "#193138",
  opacity: ".2",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 20v82a12 12 0 01-24 0V20z",
  fill: "url(#a2a20e68-5b20-4278-8e5b-3d3cb02a1a19)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134 0v102a12 12 0 01-12 12H12a12 12 0 0012-12V0z",
  fill: "url(#edc4a9b2-14b4-4193-a37d-8fb0916de50b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 20v82a12 12 0 01-24 0V20z",
  fill: "#193138",
  opacity: ".2",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("g", {
  fill: "#193138"
}, /*#__PURE__*/React.createElement("path", {
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  },
  d: "M74 30h50v52H74z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "99.35",
  cy: "49.82",
  r: "12.24",
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.65 82H78a21.7 21.7 0 0142.61 0z",
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  }
})), /*#__PURE__*/React.createElement("rect", {
  x: "34",
  y: "11",
  width: "90",
  height: "10",
  rx: "2",
  fill: "#193138",
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: "34",
  y: "30",
  width: "34",
  height: "4",
  rx: "2",
  fill: "#193138",
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: "34",
  y: "42",
  width: "34",
  height: "4",
  rx: "2",
  fill: "#193138",
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: "34",
  y: "54",
  width: "34",
  height: "4",
  rx: "2",
  fill: "#193138",
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: "34",
  y: "66",
  width: "34",
  height: "4",
  rx: "2",
  fill: "#193138",
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: "34",
  y: "78",
  width: "34",
  height: "4",
  rx: "2",
  fill: "#193138",
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: "34",
  y: "90",
  width: "90",
  height: "4",
  rx: "2",
  fill: "#193138",
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: "34",
  y: "102",
  width: "90",
  height: "4",
  rx: "2",
  fill: "#193138",
  opacity: ".25",
  style: {
    mixBlendMode: "multiply"
  }
})))));